import React, { FunctionComponent } from 'react';
import { meetingsSimplePageSelectors } from '../../../../../../app/page/page-storage/meetings-simple/meetings-simple.selectors';
import { useSelect } from '../../../../../../utils/selector.utils';
import { MeetingName } from './MeetingName';

export const NextMeeting: FunctionComponent = () => {
  const meetingId = useSelect(meetingsSimplePageSelectors.selectNextMeeting);

  return (
    <div className="panel-text ml-2">
      <span className="darkGray">
        <i className="icon-users mr-05"></i> Next Meeting:
        {meetingId.length > 0 ? (
          <>
            <MeetingName meetingId={meetingId} />
          </>
        ) : (
          '/'
        )}
      </span>
    </div>
  );
};
